import { Injectable } from '@angular/core';
import { DatasetRelatedAssetSelectedRecipient, DatasetRelatedAssetRecipientCount, DatasetSelectedRecipientFilter, DocumentsRefRelatedDocumentsRequest, RefRelatedDocumentsResponse } from '../store/communications/communications.model';
import { FieldDataType } from '@app/modules/core/store/models';
import { TemplateDesignerService } from './template-designer.service';
import { v4 as uuidv4 } from 'uuid';
import { Observable } from 'rxjs';
import { CommunicationsApiService } from '../store/communications/communications-api.service';
import { map } from 'rxjs/operators';
import { RelatedViewsService } from '@app/modules/core/components/related-documents/services/related-views.service';

@Injectable({
  providedIn: 'root'
})
export class RelatedRecipientService {

  constructor(
    private templateDesignerService: TemplateDesignerService,
    private relatedViewsService: RelatedViewsService,
    private commApiService: CommunicationsApiService
  ) { }

  public init(): void  {
    this.templateDesignerService.initDatasets();
  }

  public getRelatedAssetsInfo(datasetUId: string): DatasetRelatedAssetSelectedRecipient[] {
    const dataset = this.templateDesignerService.datasets?.find(d => d.uId === datasetUId);
    const referenceFields = dataset?.schema?.fields
      .filter(f => f.dataType === FieldDataType.ReferenceCriteria && !!f.settings?.targetDatasetUId)
      .map(f => {
        const targetDataset  = this.templateDesignerService.datasets?.find(d => d.uId === f?.settings?.targetDatasetUId);
        const relatedRecipient : DatasetRelatedAssetSelectedRecipient = {
          uId: uuidv4(),
          refFieldUId: f.uId,
          refFieldName: f.systemName!,
          datasetUId: targetDataset?.uId,
          datasetName: targetDataset?.name,
          dataasetIcon: targetDataset?.iconPath,
          isCustomIcon: targetDataset?.isCustomIcon,
          color: targetDataset?.defaultColor,
          hasDocumentFilter: this.relatedViewsService.linkFilterHasDocumentFilter(f.settings?.filterGroup)
        }
        return relatedRecipient;
      });
      return referenceFields;
  }

  public getDatasetDocumentsRelated(
    datasetUId: string,
    documentUIds: string[],
    refFieldName: string,
    countsOnly: boolean): Observable<RefRelatedDocumentsResponse> {
    const request = {
      refFieldname: refFieldName,
      queryMatchRule: null,
      documentUIds: documentUIds,
      totalCountOnly: true,
      countsOnly: countsOnly
    } as DocumentsRefRelatedDocumentsRequest;

    return this.commApiService.getDocumentsRefRelatedDocuments(datasetUId, request);
  }

  public getDatasetDocumentsRelatedCount(
    datasetUId: string,
    documentUId: string,
    relatedInfo: DatasetRelatedAssetSelectedRecipient): Observable<DatasetRelatedAssetRecipientCount>
  {
    return this.getDatasetDocumentsRelated(datasetUId, [ documentUId ], relatedInfo.refFieldName, true)
      .pipe(map(res => (
        {
          total: res.totalCount,
          contactCount: res.totalCount * this.templateDesignerService.getNumberOfContactFields(res.targetDatasetUId),
          countDisplay: relatedInfo.limitedCounts === true ? `> ${res.totalCount}` : res.totalCount.toString()
        })));
  }
}
